export default function ErrorString(props)
{
    const { error } = props;

    let errorContent;

    if ( typeof error === 'string' || error instanceof String ) {
        errorContent =  (<span className="text-xs text-[red]">{ error }</span>);
    }

    return (
        <>
            { errorContent }
        </>
    );
}